import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { observer, inject } from 'mobx-react';

import Container from '../../components/Container';
import Featured from './components/FeaturedHome';
import Scene from '../Scene';
import ContentRows from '../../components/ContentRows';
import { toVw, toVwMobile, toVwTablet } from '../../utils/styles';
import mq from '@/utils/media-queries';
import InvertingColorsBlock from '../../components/InvertingColorsBlock';
import PreviewNextPage from '../../components/PreviewNextPage';
import Title from '../../components/Title';
import { FONT_SIZE_LARGE } from '../../constants';
import Indent from '../../components/Indent';
import AnimationOnPageLoadItem from '../../components/AnimationOnPageLoadItem';

const MAIN_CONTENT_MARGIN_BOTTOM = 144;

const SCENE_PADDING_TOP = 288;

const HomeScene = styled(Scene)`
  padding-top: ${toVw(SCENE_PADDING_TOP)};

  ${mq.tablet(css`
    padding-top: ${toVwTablet(SCENE_PADDING_TOP)};
  `)};

  ${mq.mobile(css`
    padding-top: ${toVwMobile(300)};
  `)};
`;

const StyledTitle = styled(Title)`
  margin-top: 0;
  margin-bottom: ${toVw(174)};
  font-size: ${toVw(FONT_SIZE_LARGE)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(168)};
    font-size: ${toVwTablet(FONT_SIZE_LARGE)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(297)};
    font-size: ${toVwMobile(64)};
  `)};
`;

const MainContent = styled.div`
  margin-bottom: ${toVw(MAIN_CONTENT_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(MAIN_CONTENT_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(MAIN_CONTENT_MARGIN_BOTTOM)};
  `)};
`;

class Home extends React.Component {
  static propTypes = {
    homeStore: PropTypes.object,
  };

  state = {
    initialSceneNode: null,
  };

  componentDidMount() {
    this.props.homeStore.load();
    this.setState({ initialSceneNode: this.initialSceneNode });
  }

  render() {
    const {
      homeStore: { title, rows, featured, nextPreview },
      ...rest
    } = this.props;
    const featuredData = featured.toJSON();

    return (
      <HomeScene innerRef={node => (this.initialSceneNode = node)} {...rest} brightFooter>
        <Container>
          <Indent>
            <StyledTitle>
              <AnimationOnPageLoadItem>
                {title && <span data-hide-on-animation dangerouslySetInnerHTML={{ __html: title }} />}
              </AnimationOnPageLoadItem>
            </StyledTitle>
          </Indent>
        </Container>
        <MainContent>
          <Container>
            <AnimationOnPageLoadItem>
              <ContentRows items={rows.toJSON()} />
            </AnimationOnPageLoadItem>
          </Container>
        </MainContent>
        <InvertingColorsBlock shouldInvert>
          <div>
            {Object.keys(featuredData).length > 0 && <Featured {...featuredData} />}
            <PreviewNextPage {...nextPreview.toJSON()} />
          </div>
        </InvertingColorsBlock>
      </HomeScene>
    );
  }
}

export default inject(stores => ({ homeStore: stores.store.home }))(observer(Home));



// WEBPACK FOOTER //
// ./src/scenes/Home/index.js